//人事評価力診断の新動画・新フォーマット対応20250401以降
import Axios from 'axios';
import { openReport } from '../../../utils/sessionGuard'; // セッション失効時は新タブを開かず現在の画面でログインへ
import React, { Fragment, useEffect, useState, useRef } from 'react';
// import Vimeo from '@vimeo/vimeo';
import {
  Card,
  Col,
  Spin,
  Row,
  Tooltip,
  Modal,
  message,
  Typography,
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import config from '../../Config/key';
import Vimeo from '@u-wave/react-vimeo';
const { Title, Text } = Typography;
const { confirm } = Modal;
// var Vimeo = require('vimeo').Vimeo;
function Course90105Page(props) {
  const [viewModal, setViewModal] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [paused, setPaused] = useState(false);
  const [videoId, setVideoId] = useState('');
  const playerRef = useRef(null); // Vimeoプレイヤーの参照を保持
  const thumbnailURL = `${config.S3_URL}/${config.S3_ENV}/videos/fixedThumbnail/`;
  let sendData = props.location.state;
  const { userData } = props.user;
  let tokenInfo = props.location.state.tokenInfo;
  // console.log({ tokenInfo });
  let surveyStatus = sendData.tokenInfo.survey_status === 5 ? true : false;

  useEffect(() => {}, []);
  // モーダルを閉じる前にビデオを完全に停止
  const closeModal = () => {
    // プレイヤーが存在する場合、明示的に一時停止
    if (playerRef.current) {
      try {
        playerRef.current.pause();
        playerRef.current.unload(); // ビデオを完全にアンロード
      } catch (error) {
        console.log('ビデオ停止エラー:', error);
      }
    }

    // プレイヤー参照をクリア
    playerRef.current = null;

    // 状態をリセット
    setVideoId(''); // ビデオIDをリセット
    setPaused(false); // paused状態を初期化

    // 少し遅延してモーダルを閉じる
    setTimeout(() => {
      setViewModal(false);
    }, 100);
  };

  // モーダルでのOK
  const handleOk = (e) => {
    closeModal();
  };

  const handleCancel = (e) => {
    closeModal();
  };
  const handleOnPause = (e) => {
    console.log({ e });
    // setPaused(true);
    setViewModal(false);
  };

  // カードクリック時の処理 - 新しいビデオを設定してモーダルを開く
  const handleCardClick = (v) => {
    // console.log(v);
    if (v === 'takeSurvey') {
      sendData.tokenInfo.survey_code = '10010';
      // console.log({ sendData });
      props.history.push({
        pathname: '/newtakesurvey',
        state: sendData,
      });
    } else {
      setVideoId(v);
      setPaused(false);
      setViewModal(true);
    }
  };

  // Vimeoプレイヤーの準備完了時の処理
  const handleReady = (player) => {
    playerRef.current = player;
  };

  const showConfirm = async () => {
    confirm({
      title: 'サーベイ結果を生成しますか？',
      content:
        'サーベイ結果を生成し別TabでPDF表示します。このままお待ちください。',
      async onOk() {
        setIsModalVisible(true);
        let ti = tokenInfo;
        const seasonInfo = await Axios.get(
          `/api/surveySeason/${tokenInfo.survey_season_id}`
        );
        // console.log({ seasonInfo });
        ti.group_name = userData.company;
        ti.company = userData.company;
        ti.study_end_date = tokenInfo.updateAt;
        ti.survey_start_date = seasonInfo.data.surveySeason.survey_start_date;
        ti.survey_end_date = seasonInfo.data.surveySeason.survey_end_date;
        ti.training_start_date =
          seasonInfo.data.surveySeason.training_start_date;
        ti.training_end_date = seasonInfo.data.surveySeason.training_end_date;

        ti.survey_name = tokenInfo.surveyName;
        ti.emp_no = userData.empNo;
        ti.department = userData.department;
        ti.user_name = userData.lastname + ' ' + userData.name;
        let result = await Axios.post('/api/dbModel100/makeReport', ti);
        // console.log({ result });
        if (result.data.success) {
          // message.success('結果生成が完了しました。マイ・サーベイに戻ります。');
          // props.history.push('/mysurvey');
          // サーバープロキシ経由でPDFを表示（S3 URLを露出しない）
          message.success({
            content: 'ファイル生成完了！',
            key: 'makecsv',
            duration: 2,
          });
          setIsModalVisible(false);
          openReport(result.data.tokenId);
        } else {
          setIsModalVisible(false);
          console.log('結果生成で問題が発生しました。');
          message.error('結果生成で問題が発生しました。');
        }
      },
      async onCancel() {},
    });
  };

  return (
    <Fragment>
      <div style={{ width: '90%', margin: '1rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>評価者育成プログラム</Title>
        </div>
        {sendData.tokenInfo.coursePartView[0] ? (
          <Card
            title="人事評価の基本"
            styles={{ header: { backgroundColor: 'var(--blue-active)', color: 'var(--white)' }, body: { backgroundColor: 'var(--brand-cream)' } }}
            extra={
              <Tooltip
                placement="bottomRight"
                title={
                  'ここでは、人事評価の基本的な考え方や運用について学習します。\n【学習時間目安：10分】'
                }
                color={'var(--brand-primary)'}
                key={'orange'}
              >
                <QuestionCircleOutlined
                  style={{ fontSize: '25px', color: 'var(--white)' }}
                />
              </Tooltip>
            }
          >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Card
                  hoverable
                  cover={
                    <div style={{ position: 'relative' }}>
                      <img
                        style={{ width: '100%' }}
                        alt="人事評価の目的"
                        src={thumbnailURL + '7.png'}
                      />
                      <div className="duration">
                        <span>
                          {('00' + 4).slice(-2)} : {('00' + 28).slice(-2)}
                        </span>
                      </div>
                    </div>
                  }
                  onClick={() => handleCardClick('799314299')}
                >
                  <div className="video-card-title">人事評価の目的</div>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Card
                  hoverable
                  cover={
                    <div style={{ position: 'relative' }}>
                      <img
                        style={{ width: '100%' }}
                        alt="人事評価制度の基本的な知識"
                        src={thumbnailURL + '7.png'}
                      />
                      <div className="duration">
                        <span>
                          {('00' + 5).slice(-2)} : {('00' + 8).slice(-2)}
                        </span>
                      </div>
                    </div>
                  }
                  onClick={() => handleCardClick('799314894')}
                >
                  <div className="video-card-title">人事評価制度の基本的な知識</div>
                </Card>
              </Col>
            </Row>
          </Card>
        ) : (
          <></>
        )}
        <br />
        {sendData.tokenInfo.coursePartView[1] ? (
          <Card
            title="人事評価力診断"
            styles={{ header: { backgroundColor: 'var(--blue-active)', color: 'var(--white)' }, body: { backgroundColor: 'var(--brand-cream)' } }}
            extra={
              <Tooltip
                placement="bottomRight"
                title={
                  'ここでは、人事評価力診断の受検方法や結果の見方について学習します。\n【学習時間の目安：10分】'
                }
                color={'var(--brand-primary)'}
                key={'orange'}
              >
                <QuestionCircleOutlined
                  style={{ fontSize: '25px', color: 'var(--white)' }}
                />
              </Tooltip>
            }
          >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Card
                  hoverable
                  cover={
                    <div style={{ position: 'relative' }}>
                      <img
                        style={{ width: '100%' }}
                        alt="診断概要紹介"
                        src={thumbnailURL + '19.png'}
                      />
                      <div className="duration">
                        <span>
                          {('00' + 1).slice(-2)} : {('00' + 39).slice(-2)}
                        </span>
                      </div>
                    </div>
                  }
                  onClick={() => handleCardClick('1055859666')}
                >
                  <div className="video-card-title">診断概要紹介</div>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable={false}
                    cover={
                      <img alt="診断受検完了" src={thumbnailURL + 'd_5.png'} />
                    }
                  >
                    <div className="video-card-title">診断受検完了</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={true}
                    cover={
                      <img
                        alt="診断受検はこちら"
                        src={thumbnailURL + '5.png'}
                        onClick={() => handleCardClick('takeSurvey')}
                      />
                    }
                  >
                    <div className="video-card-title">診断受検はこちら</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable={true}
                    cover={
                      <img
                        alt="診断結果PDFダウンロード"
                        src={thumbnailURL + '4.png'}
                        onClick={showConfirm}
                      />
                    }
                  >
                    <div className="video-card-title">診断結果PDFダウンロード</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <img
                        alt="診断結果PDFダウンロード"
                        src={thumbnailURL + 'd_4.png'}
                      />
                    }
                  >
                    <div className="video-card-title">診断結果PDFダウンロード</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="診断結果の読み方①"
                          src={thumbnailURL + '20.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 3).slice(-2)} : {('00' + 43).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('1055860029')}
                  >
                    <div className="video-card-title">診断結果の読み方①</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="診断結果の読み方①"
                          src={thumbnailURL + 'd_20.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">診断結果の読み方①</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    style={{ marginTop: 20 }}
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="診断結果の読み方②"
                          src={thumbnailURL + '20.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 11).slice(-2)} : {('00' + 11).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('1055860357')}
                  >
                    <div className="video-card-title">診断結果の読み方②</div>
                  </Card>
                ) : (
                  <Card
                    style={{ marginTop: 20 }}
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="診断結果の読み方②"
                          src={thumbnailURL + 'd_20.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">診断結果の読み方②</div>
                  </Card>
                )}
              </Col>
            </Row>
          </Card>
        ) : (
          <></>
        )}
        <br />
        {sendData.tokenInfo.coursePartView[2] ? (
          <Card
            title="評価エラー傾向の解説"
            styles={{ header: { backgroundColor: 'var(--blue-active)', color: 'var(--white)' }, body: { backgroundColor: 'var(--brand-cream)' } }}
            extra={
              <Tooltip
                placement="bottomRight"
                title={
                  'ここでは、人事評価における6つのエラー傾向について学習します。\n【学習時間の目安：35分】'
                }
                color={'var(--brand-primary)'}
                key={'orange'}
              >
                <QuestionCircleOutlined
                  style={{ fontSize: '25px', color: 'var(--white)' }}
                />
              </Tooltip>
            }
          >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="ハロー効果"
                          src={thumbnailURL + '9.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 5).slice(-2)} : {('00' + 17).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('1055860823')}
                  >
                    <div className="video-card-title">ハロー効果</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="ハロー効果"
                          src={thumbnailURL + 'd_9.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">ハロー効果</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="寛大化傾向"
                          src={thumbnailURL + '10.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 6).slice(-2)} : {('00' + 16).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('1055861570')}
                  >
                    <div className="video-card-title">寛大化傾向</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="寛大化傾向"
                          src={thumbnailURL + 'd_10.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">寛大化傾向</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="逆算化傾向"
                          src={thumbnailURL + '11.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 5).slice(-2)} : {('00' + 10).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('1055862126')}
                  >
                    <div className="video-card-title">逆算化傾向</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="逆算化傾向"
                          src={thumbnailURL + 'd_11.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">逆算化傾向</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="対比誤差"
                          src={thumbnailURL + '12.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 6).slice(-2)} : {('00' + 27).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('1055862513')}
                  >
                    <div className="video-card-title">対比誤差</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="対比誤差"
                          src={thumbnailURL + 'd_12.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">対比誤差</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    style={{ marginTop: 20 }}
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="中心化傾向"
                          src={thumbnailURL + '13.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 7).slice(-2)} : {('00' + 49).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('1055862762')}
                  >
                    <div className="video-card-title">中心化傾向</div>
                  </Card>
                ) : (
                  <Card
                    style={{ marginTop: 20 }}
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="中心化傾向"
                          src={thumbnailURL + 'd_13.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">中心化傾向</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    style={{ marginTop: 20 }}
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="論理誤差"
                          src={thumbnailURL + '14.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 7).slice(-2)} : {('00' + 17).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('1055863121')}
                  >
                    <div className="video-card-title">論理誤差</div>
                  </Card>
                ) : (
                  <Card
                    style={{ marginTop: 20 }}
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="論理誤差"
                          src={thumbnailURL + 'd_14.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">論理誤差</div>
                  </Card>
                )}
              </Col>
            </Row>
          </Card>
        ) : (
          <></>
        )}
        <br />
        {sendData.tokenInfo.coursePartView[3] ? (
          <Card
            title="目標設定面談"
            styles={{ header: { backgroundColor: 'var(--blue-active)', color: 'var(--white)' }, body: { backgroundColor: 'var(--brand-cream)' } }}
            extra={
              <Tooltip
                placement="bottomRight"
                title={
                  'ここでは、目標設定面談の目的やその進め方について学習します。【学習時間の目安：30分】'
                }
                color={'var(--brand-primary)'}
                key={'orange'}
              >
                <QuestionCircleOutlined
                  style={{ fontSize: '25px', color: 'var(--white)' }}
                />
              </Tooltip>
            }
          >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="目標設定面談"
                          src={thumbnailURL + '15.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 7).slice(-2)} : {('00' + 27).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('799369289')}
                  >
                    <div className="video-card-title">目標設定面談</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="目標設定面談"
                          src={thumbnailURL + 'd_15.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">目標設定面談</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="中間面談"
                          src={thumbnailURL + '16.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 10).slice(-2)} : {('00' + 19).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('799369934')}
                  >
                    <div className="video-card-title">中間面談</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="中間面談"
                          src={thumbnailURL + 'd_16.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">中間面談</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="評価面談①"
                          src={thumbnailURL + '17.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 8).slice(-2)} : {('00' + 7).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('799370335')}
                  >
                    <div className="video-card-title">評価面談①</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="評価面談①"
                          src={thumbnailURL + 'd_17.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">評価面談①</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="評価面談②"
                          src={thumbnailURL + '18.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 8).slice(-2)} : {('00' + 33).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('799370686')}
                  >
                    <div className="video-card-title">評価面談②</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="評価面談②"
                          src={thumbnailURL + 'd_18.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">評価面談②</div>
                  </Card>
                )}
              </Col>
            </Row>
          </Card>
        ) : (
          <></>
        )}
        <br />
        {/* {sendData.tokenInfo.coursePartView[4] ? (
          <Card
            title="資料DL / 確認テスト"
            styles={{ header: { backgroundColor: 'var(--blue-active)', color: 'var(--white)' }, body: { backgroundColor: 'var(--brand-cream)' } }}
            extra={
              <Tooltip
                placement="bottomRight"
                title={'参考資料のダウンロードができます。'}
                color={'var(--brand-primary)'}
                key={'orange'}
              >
                <QuestionCircleOutlined
                  style={{ fontSize: '25px', color: 'var(--white)' }}
                />
              </Tooltip>
            }
          >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <img
                        alt="評価ハンドブック"
                        src={thumbnailURL + '1.png'}
                      />
                    }
                    variant="outlined"
                  >
                    <div className="video-card-title">評価ハンドブック</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <img
                        alt="評価ハンドブック"
                        src={thumbnailURL + 'd_1.png'}
                      />
                    }
                    variant="outlined"
                  >
                    <div className="video-card-title">評価ハンドブック</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={<img alt="問題集" src={thumbnailURL + '2.png'} />}
                    variant="outlined"
                  >
                    <div className="video-card-title">問題集</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={<img alt="問題集" src={thumbnailURL + 'd_2.png'} />}
                    variant="outlined"
                  >
                    <div className="video-card-title">問題集</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={<img alt="解説資料" src={thumbnailURL + '3.png'} />}
                    variant="outlined"
                  >
                    <div className="video-card-title">解説資料</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <img alt="解説資料" src={thumbnailURL + 'd_3.png'} />
                    }
                    variant="outlined"
                  >
                    <div className="video-card-title">解説資料</div>
                  </Card>
                )}
              </Col>
            </Row>
          </Card>
        ) : (
          <></>
        )} */}
      </div>
      {/* モーダルが開いているときのみレンダリング */}
      {viewModal && (
        <div>
          <Modal
            title="動画再生"
            open={viewModal}
            onOk={handleOk}
            onCancel={handleCancel}
            styles={{ body: { overflowX: 'scroll' } }}
            width={1000}
            footer={null}
            destroyOnHidden={true} // モーダルを閉じるときに子要素を完全に破棄
            maskClosable={false} // マスククリックで閉じるのを無効化
          >
            {videoId && ( // videoIdがある場合のみレンダリング
              <Vimeo
                key={`vimeo-${videoId}-${Date.now()}`} // ユニークなkeyを生成
                video={videoId}
                className="vimeo pc"
                responsive
                autoplay={true}
                speed={true}
                paused={paused}
                onReady={handleReady} // プレイヤー準備完了時の処理
              />
            )}
          </Modal>
        </div>
      )}
      <Modal
        title="サーベイ結果ファイル生成中..."
        open={isModalVisible}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        styles={{ body: { textAlign: 'center' } }}
      >
        <Spin size="large" />
      </Modal>
    </Fragment>
  );
}

export default Course90105Page;
